import { useNavigate, useLocation } from "react-router-dom";
import NavItems from "@/components/navigation/NavItems";
import { UserProfileInfo } from "@/components/navigation/UserProfileInfo";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { debugLogger } from '@/utils/debugLogger';
import { useUserRole } from '@/hooks/useUserRole';
import InterlacedLogoV2 from "@/components/ui/InterlacedLogoV2";
const DesktopSidebar = () => {
  const navigate = useNavigate();
  const currentRoute = useLocation().pathname;
  const {
    user,
    profileData
  } = useAuth();
  const isOnboardingRoute = currentRoute.includes('/onboarding');
  // Only hide sidebar for onboarding verification, not main verification
  const isVerificationRoute = currentRoute.includes('/onboarding') && currentRoute.includes('/verify');

  // Don't render the sidebar on onboarding or onboarding verification routes
  if (isOnboardingRoute || isVerificationRoute) {
    return null;
  }
  const handleNavItemClick = () => {
    // Simple click handler without parameters
  };
  const handleProfileClick = () => {
    navigate('/main/profile');
  };
  const handleLogout = () => {
    debugLogger.debug('DesktopSidebar: Navigating to logout');
    navigate('/main/logout');
  };

  // Check if current user has admin privileges (server-side validation)
  const {
    isAdmin
  } = useUserRole();
  return <aside className="hidden md:flex md:w-52 lg:w-64 flex-col bg-black border-r border-white/10 fixed left-0 top-0 h-screen z-40">
      <div className="h-[68px] px-4 border-b border-white/10 flex items-center justify-center">
        <InterlacedLogoV2 variant="horizontal" size="md" as="h1" />
      </div>
      
      <nav className="flex-1 md:p-3 lg:p-4 space-y-12 overflow-y-auto px-[16px] py-0">
        <NavItems isMobile={false} onItemClick={handleNavItemClick} />
        
        {/* Verification Button */}
        
        
        {/* Feedback Button */}
        
        
        {/* Admin Menu for users with admin or moderator role */}
        {isAdmin}
      </nav>

      {profileData && <div className="md:p-3 lg:p-4 border-t border-white/10 cursor-pointer hover:bg-white/5 transition-colors" onClick={handleProfileClick}>
          <UserProfileInfo />
        </div>}
      
      {/* Logout Button */}
      <div className="md:p-3 lg:p-4 border-t border-white/10">
        <Button variant="ghost" className="w-full justify-start text-red-400 hover:bg-red-400/10 hover:text-red-400 transition-colors" onClick={handleLogout}>
          <LogOut className="h-5 w-5 mr-3" />
          Sair
        </Button>
      </div>
    </aside>;
};
export default DesktopSidebar;